import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";


import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { QueryState } from "@/shared/ui/QueryState";
import { useBranchQuery, useUpdateBranch } from "../api/queries";
import { BranchForm, branchToFormValues } from "../ui/BranchForm";

export function BranchesEditPage() {
  const nav = useNavigate({ from: "/app/branches/$id/edit" });
  const { id } = useParams({ from: "/app/branches/$id/edit" });
  const { data: branch, ...queryResult } = useBranchQuery(id);
  const updateBranch = useUpdateBranch(id);

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            {
              label: "ສາຂາ",
              to: "/app/branches",
            },
            {
              label: "ແກ້ໄຂສາຂາ",
            },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-6 flex flex-wrap items-center justify-between gap-2">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">
              ແກ້ໄຂສາຂາ
            </h2>
            <p className="text-muted-foreground">
              ຈັດການຕຳແໜ່ງສາຂາ ລັງສີບໍລິການ ແລະ ເວລາເປີດໃຫ້ບໍລິການ.
            </p>
          </div>
          <Button variant="outline" onClick={() => nav({ to: "/app/branches" })}>
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <QueryState
          result={queryResult}
          title="ກຳລັງໂຫຼດສາຂາ"
          description="ກຳລັງດຶງລາຍລະອຽດ"
          variant="fullscreen"
        >
          {!branch ? null : (
            <BranchForm
              initialValues={branchToFormValues(branch)}
              onSubmit={async (vals) => {
                try {
                  await updateBranch.mutateAsync({
                    code: vals.code,
                    name: vals.name,
                    phone: vals.phone ?? null,
                    address: vals.address ?? null,
                    lat: vals.lat ?? null,
                    lng: vals.lng ?? null,
                    serviceRadiusM: vals.serviceRadiusM ?? null,
                    timezone: vals.timezone ?? null,
                    openHoursJson: vals.openHoursJson,
                    isActive: vals.isActive,
                    isDistributionHub: vals.isDistributionHub,
                  });
                  toast.success("ບັນທຶກການປ່ຽນແປງສຳເລັດ", {
                    description: "ສາຂາຖືກອັບເດດແລ້ວ",
                  });
                  nav({ to: "/app/branches" });
                } catch {
                  // onError in mutation shows toast
                }
              }}
              submitting={updateBranch.isPending}
              onCancel={() => nav({ to: "/app/branches" })}
            />
          )}
        </QueryState>
      </Main>
    </>
  );
}
